<section class="main-section">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Products</li>
    </ol>
  </nav>


  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div *ngIf="totalCount>0">
    <div class="row align-items-center">
      <div class="col-5">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of inventoriesMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of inventoriesMainMenu" [ngValue]="u.orderStatus">{{u.displayName}}</option>
        </select>
      </div>
      <div class="col-5 ml-auto text-right float-right">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button [hidden]="user.role === 'ACCOUNT_OWNER'" type="button" routerLink="/admin/adjustInventoryProduct"
                  class="btn btn-outline-primary btn-sm ml-2" style="border-radius: 4px;">Adjust Inventory
          </button>
          <a placement="bottom" ngbTooltip="Import" data-toggle="modal" data-target="#buttonModal" class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }

                .b {
                  fill: #fff;
                }</style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M.457,8.222A.458.458,0,0,0,0,8.679v.914a.458.458,0,0,0,.457.457h3.2V8.222ZM14.417,3,11.622.2a.685.685,0,0,0-.485-.2h-.174V3.654h3.654V3.48A.683.683,0,0,0,14.417,3Zm-4.368.885V0H4.339a.684.684,0,0,0-.685.685V8.222H7.309V6.361a.458.458,0,0,1,.782-.323L10.82,8.793a.486.486,0,0,1,0,.685L8.088,12.23a.458.458,0,0,1-.782-.323V10.049H3.654v3.883a.684.684,0,0,0,.685.685h9.593a.684.684,0,0,0,.685-.685V4.568H10.734A.687.687,0,0,1,10.049,3.883Z"
                      transform="translate(3.356 5.479)"/>
              </g>
            </svg>
          </a>
          <a placement="bottom" ngbTooltip="Create" class="ml-2"
             [hidden]="totalCount > 9 && (user.role == 'DEMO_ACCOUNT')">
            <svg xmlns="http://www.w3.org/2000/svg" (click)="submitAdmin()" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }

                .b {
                  fill: #fff;
                }</style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                      transform="translate(2.823 3.938)"/>
              </g>
            </svg>
          </a>
        </div>
      </div>

    </div>

  </div>

  <div class="row" *ngIf="totalCount === 0 && !loading">
    <div class="col">
      <div class="inner-box no-listbox">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <img src="assets/images/Emptyscreen - Products.png">
          </div>
          <div class="col-md-6">
            <h2>Be the one to start</h2>
            <h1 class="f-46 text-orange">Create your first Product!!</h1>
            <div class="row">
              <div class="col-md-3">
                <a (click)="submitAdmin()">
                  <button class="btn btn-orange-prime mt-4">Create now</button>
                </a>
              </div>
              <div class="col-md-3">
                <a data-toggle="modal" data-target="#buttonModal">
                  <button class="btn btn-orange-prime mt-4">Import Products</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="!totalCount">
    <div class="row">
      <div class="col">
        <div class="inner-box d-none d-sm-block">
          <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead>
            <tr>
              <th
                *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER' && accessSec.editProduct)"
                [hidden]="tabClicked === 'all'">
                <!--<div class="form-checkbox">
                    <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                    <label for="all_items"></label>
                </div>-->
              </th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Creation Date</th>
              <th>HSN</th>
              <th><span>Status</span></th>
            </tr>
            </thead>
            <tbody class="table-body-custom">
            <tr *ngFor="let p of products;let i=index;">
              <td *ngIf="user.role === 'ACCOUNT_OWNER' ||(user.role === 'ROLE_USER' && accessSec.editProduct)"
                  [hidden]="tabClicked === 'all'">
                <!--<div class="form-checkbox">
                    <input type="checkbox" id="{{p.productId}}" [(ngModel)]="p.isSelected" name="list_name" (change)="selectShip(p)">
                    <label for="{{p.productId}}"></label></div>-->
              </td>
              <td><a routerLink="/admin/InventoriesView/{{p.productId}}" (cbOnSuccess)="copied($event)" ngxClipboard
                     [cbContent]="p.storeSku" [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editProduct)}"
                     style="text-transform:uppercase;">{{(p.storeSku ? (p.storeSku) : (p.sku) | uppercase)}}</a></td>
              <td>
                <div class="textminwid" ngxClipboard [cbContent]="p.productName"
                     ngbTooltip="{{p.productName | titlecase}}" (cbOnSuccess)="copied($event)">{{p.productName}}
                </div>
              </td>
              <td>{{p.createdDate}}</td>
              <td>{{p.hsnCode | titlecase}}</td>
              <td>
                <div class="toggle-2"
                     [ngClass]="{'inventory-status':(user.role === 'ROLE_USER' && !accessSec.editProduct)}">
                  <input type="checkbox" name="onoffswitch" (click)="updateStatus(p)"
                         id="customSwitch_{{p.productId}}"
                         [disabled]="(user.role === 'ROLE_USER' && !accessSec.editProduct)"
                         [checked]="p.status==='ACTIVE'" class="checkbox"/>
                  <label for="customSwitch_{{p.productId}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="display-msg text-center">
            {{displayMsg}}
          </div>
        </div>
        <div class="inner-box d-block d-sm-none">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead>
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Creation Date</th>
              <th>HSN</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let p of products;let i=index;">
              <td>
                <b class=" tablesaw-cell-label">SKU </b>
                <span class="tablesaw-cell-content"><a routerLink="/admin/InventoriesView/{{p.productId}}"
                                                       [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editProduct)}"
                                                       style="text-transform:uppercase;"> {{p.storeSku}}</a></span></td>
              <td><b class=" tablesaw-cell-label">Product Name </b>
                <span class="tablesaw-cell-content">{{p.productName}}</span></td>
              <td>
                <b class=" tablesaw-cell-label">Creation Date</b>
                <span class="tablesaw-cell-content">{{p.createdDate}}</span></td>
              <td>
                <b class=" tablesaw-cell-label">HSN</b>
                <span class="tablesaw-cell-content">{{p.hsnCode}}</span></td>
              <td>
                <b class=" tablesaw-cell-label">Status</b>
                <span class="tablesaw-cell-content">
                <div class="custom-control custom-switch inventory-status"
                     [ngClass]="{'inventory-status':(user.role === 'ROLE_USER' && !accessSec.editProduct)}">
                  <input type="checkbox" class="custom-control-input" (click)="updateStatus(p)"
                         id="customsSwitch_{{p.productId}}"
                         [disabled]="(user.role === 'ROLE_USER' && !accessSec.editProduct)"
                         [checked]="p.status==='ACTIVE'">
                  <label class="custom-control-label" for="customsSwitch_{{p.productId}}"></label>
                </div></span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="onHandQuantityModal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">On Hand Quantity</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <table class="table p-5">
          <thead>
          <th>Warehouse Name</th>
          <th>Quantity</th>
          </thead>
          <tbody>
          <tr *ngFor="let p of onHandQuantityRecords">
            <td class="">{{p.warehouseName}}</td>
            <td class="">{{p.quantity}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="buttonModal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Select Products</h4>
        <button type="button" (click)="reset()" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body ml-2">
        <div class="form-radio mr-5">
          <input type="radio" name="skuConfig" [(ngModel)]="selectImport" (click)="removeFile()"
                 [ngModelOptions]="{standalone: true}" id="importProducts" required value="PRODUCTS">
          <label for="importProducts">Import Products
          </label>
        </div>
      </div>

      <div class="modal-body ml-2" *ngIf="selectImport === 'PRODUCTS'">
        <h4 style="padding-inline:7px;">Import Products</h4>
        <div>
          <p style="font-size:15px; padding-inline:7px;">To import your Products, please create a CSV file with
            following details and upload.
            <br/>Sample file can be accessed <a
              href="https://shift-images.s3.ap-south-1.amazonaws.com/ao_products_import.csv" target="_blank">here</a>
          </p>
          <div class="row">
            <div class="col" style="height:44px; padding-right:23px;">
              <label class="import_products add_file">
                <input class="shift-import-input" type="file" (change)="loadorder($event)" [(ngModel)]="productImage"
                       [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
                <span *ngIf="!productImage || productImage == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                        style="margin-right: 10px;" alt="productImage">Add file</span>
                <span *ngIf="productImage"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                                (click)="removeFile()" alt="productImage">{{getFileName(productImage)}}</span>

              </label>
              <div id="statusText2" class="invalid-feedback d-block mb-2" [hidden]="!statusText2">{{statusText2}}</div>
              <button type="button" *ngIf="productImage" style="margin-bottom:50px;"
                      class="btn btn-orange file shift-import ml-2" [attr.data-dismiss]="uploadDismissModal"
                      (click)="submitImportProduct()" data-toggle="modal" [attr.data-target]="uploadPopup">
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div [ngClass]="{'modal': statusUpdate == 'Y'}" [ngStyle]="{'display': statusUpdate  == 'Y'? 'block' : 'none'}" style="overflow-y:auto"  class="modal fade show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="padding-top:100px;">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="closepopUpRequest()">&times;</button>
      </div>
      <div class="modal-body">
        <label class="mb-3">Do you want update the status</label>
      </div>
      <div class="modal-footer">
        <button (click)="closepopUpRequest()" class="btn btn-cancel" type="button">No</button>
        <button (click)="changeStatus()" class="btn icon-left btn-orange-primary ml-3" type="button">Yes
        </button>
      </div>
    </div>
  </div>
</div>
